<template lang="pug">
  main
    NavBarCORP
    Loader(v-show="isLoading")
    section.section
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Registro de actividades de SASISOPA
            a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns
          .column.is-12.has-text-centered
            .table-responsive
              table#tblLogs.table.is-striped.is-fullwidth
                thead
                  tr
                    th #
                    th Usuario
                    th Evento
                    th dirección IP
                    th Sistema
                    th Fecha
                tbody
                  tr(v-for="(data, index) in logs" :key="data.id")
                    td {{ data.id }}
                    td
                      span {{ data.user_id }}
                    td {{ data.event }}
                    td {{ data.ip_address }}
                    td {{ data.user_agent }}
                    td {{ data.created_at }}
</template>

<script>
  import { mapState } from "vuex"
  import sasisopaAPI from "@/services/axios_sasisopa.js";
import Loader from '@/components/shared/Loader.vue'
import NavBarCORP from '@/components/layout/NavBarCorpo.vue'
  export default {
    name: 'logs',
    components: { Loader, NavBarCORP },
    props: {
      updateComponente: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        isLoading: false,
        logs: [],
      }
    },
    methods: {
      async fetchData() {
      try {
        this.isLoading = true;
        const response = await sasisopaAPI.getLogs(this.$route.params.id);
        this.logs = response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.isLoading = false;
      }
    },

      backPage() {
      this.$router.back()
      },
    },
    computed: {
      ...mapState(["logueado", "userLogin"])
    },
    created () {
      this.fetchData()
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/sasisopa/logs.vue